import Base from "../../../base";

export default class Ad extends Base {

  constructor() {
    super()
    this.setup()
  }

  controller_name = "ads"

  setup() {
    // メニューアクティブ化
    $( '.navbar .navbar-nav .nav-reserve' ).parent( 'li' ).addClass( 'active' )

    // reserve
    $(document).on('click', "#reserve-back-button",(e) => this.reserve_back_button(e))
    $(document).on('click', "#next-button",(e) => this.next_button(e))
    $(document).on('click', "#prev-button",(e) => this.prev_button(e))
    $(document).on('click', "#reserve-date-button",(e) => this.reserve_date_button(e))
    $(document).on('click', "#reserve-create-button",(e) => this.reserve_create_button(e))
    $(document).on('click', "#reserve-create-confirm-button",(e) => this.reserve_create_confirm_button(e))

    // user
    $(document).on('click', "#password-eye-button",(e) => this.password_eye_button(e))
    $(document).on('click', "#user-create-button",(e) => this.user_create_button(e))
    $(document).on('click', "#user-login-button",(e) => this.user_login_button(e))

    // login
    $(document).on('click', "#login-regist-button",(e) => this.login_regist_button(e))
    $(document).on('click', "#login-button",(e) => this.login_button(e))

    // confirm
    $(document).on('click', "#confirm-reserve-back-button",(e) => this.confirm_reserve_back_button(e))
    $(document).on('click', "#confirm-user-back-button",(e) => this.confirm_user_back_button(e))
    $(document).on('click', "#check-privacy-policy",(e) => this.check_privacy_policy(e))
    $(document).on('click', "#completed-button",(e) => this.completed_button(e))

  }

  // reserve -----------------------------------------------------------------------------------------------------------
  // オンライン／来院を変更するボタン
  reserve_back_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_reserve_back`,
      type: "PATCH",
      data: $("#reserve-submit-form").serialize(),
      callback: (data) => {
        let $url = `/${this.controller_name}/online/${data.token}`
        this.form($url)
      }
    }
    this.ajax(_params)
  }

  // 次の週へ
  next_button(e) {
    this.fadeIn()

    let _params = {
      url: `/${this.controller_name}/next_timeline`,
      type: "POST",
      data: $("#reserve-submit-form").serialize(),
      callback: (data) => {
        if (data.result) {
          $('#timeline').html(data.html);
          // timeline系hiddenをセット
          this.set_timeline_hidden(data)

          this.scroll('#border-timeline')

        } else {
          alert(data.message);
        }
        this.fadeOut()
      }
    }

    this.ajax(_params)

  }

  // 前の週へ
  prev_button(e) {
    this.fadeIn()

    let _params = {
      url: `/${this.controller_name}/prev_timeline`,
      type: "POST",
      data: $("#reserve-submit-form").serialize(),
      callback: (data) => {
        if (data.result) {
          $('#timeline').html(data.html);
          // timeline系hiddenをセット
          this.set_timeline_hidden(data)

          this.scroll('#border-timeline')

        } else {
          alert(data.message);
        }
        this.fadeOut()
      }
    }

    this.ajax(_params)

  }

  // タイムライン予約枠ボタン
  reserve_date_button(e){
    // 現在のactiveを削除
    var active = $(document).find('#reserve-table').find('.active');
    active.removeClass('active');

    // 新しくactiveを付与
    let target = $(e.currentTarget)
    target.addClass('active');

    var dt = target.data('dt');
    var start_time = target.data('start-time');
    var end_time = target.data('end-time');
    $('#reserve-date-hidden').val(dt);
    $('#start-time-hidden').val(start_time);
    $('#end-time-hidden').val(end_time);

    // お客様情報入力へボタン活性化
    $("#reserve-create-button").prop("disabled", false);
    // 予約内容確認へへボタン活性化
    $("#reserve-create-confirm-button").prop("disabled", false);

  }

  // お客様情報入力へボタン
  reserve_create_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_reserve_create`,
      type: "PATCH",
      data: $("#reserve-submit-form").serialize(),
      callback: (data) => {
        let $url = `/${this.controller_name}/${data.code}/user/${data.token}`
        this.form($url)
      }
    }
    this.ajax(_params)
  }

  // 予約内容確認へボタン
  reserve_create_confirm_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_reserve_create`,
      type: "PATCH",
      data: $("#reserve-submit-form").serialize(),
      callback: (data) => {
        let $url = `/${this.controller_name}/${data.code}/confirm/${data.token}`
        this.form($url)
      }
    }
    this.ajax(_params)
  }

  // user -----------------------------------------------------------------------------------------------------------

  // パスワード表示アイコンクリック
  password_eye_button(e) {
    let target = $(e.currentTarget)

    if ($("#password").attr("type") === "password") {
      $("#password").attr("type", "text")
      target.removeClass("fa-eye")
      target.addClass("fa-eye-slash")
    } else {
      $("#password").attr("type", "password")
      target.removeClass("fa-eye-slash")
      target.addClass("fa-eye")
    }
  }

  // ログイン
  user_login_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_user_login`,
      type: "PATCH",
      data: $("#user-submit-form").serialize(),
      callback: (data) => {
        let $url = `/${this.controller_name}/${data.code}/login/${data.token}`
        this.form($url)
      }
    }
    this.ajax(_params)
  }

  // 予約内容確認へ
  user_create_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_user_create`,
      type: "PATCH",
      data: $("#user-submit-form").serialize(),
      callback: (data) => {
        if (data.result) {
          let $url = `/${this.controller_name}/${data.code}/confirm/${data.token}`
          this.form($url)
        }else{
          $("#user-form-area").html(data.form)
          this.fadeOut()
        }
      }
    }
    this.ajax(_params)
  }

  // login -----------------------------------------------------------------------------------------------------------
  // 新規登録ボタン
  login_regist_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_login_regist`,
      type: "PATCH",
      data: $("#login-submit-form").serialize(),
      callback: (data) => {
        let $url = `/${this.controller_name}/${data.code}/user/${data.token}`
        this.form($url)
      }
    }
    this.ajax(_params)
  }

  // ログイン
  login_button(e) {
    this.fadeIn()
    let _params = {
      url: `/${this.controller_name}/ajax_login`,
      type: "PATCH",
      data: $("#login-submit-form").serialize(),
      callback: (data) => {
        if (data.result) {
          let $url = `/${this.controller_name}/${data.code}/confirm/${data.token}`
          this.form($url)
        }else{
          $("#login-form-area").html(data.form)
          this.fadeOut()
        }
      }
    }
    this.ajax(_params)
  }

  // confirm  ----------------------------------------------------------------------------------------------------------

  // 予約内容を変更する 戻るボタン
  confirm_reserve_back_button(e) {
    let $target = $(e.currentTarget)
    let $token = $target.data("token")
    let $code = $target.data("code")
    let $url = `/${this.controller_name}/${$code}/reserve/${$token}`
    this.form($url)
  }

  // 個人情報確認チェック
  check_privacy_policy(e) {
    let $target = $(e.currentTarget)

    if ($target.prop('checked') === true) {
      // 予約確定ボタン活性化
      $("#completed-button").prop("disabled", false);
    } else {
      // 予約確定ボタン非活性化
      $("#completed-button").prop("disabled", true);
    }
  }

  // お客様情報を変更する 戻るボタン
  confirm_user_back_button(e) {
    let $target = $(e.currentTarget)
    let $code = $target.data("code")
    let $token = $target.data("token")
    let $url = `/${this.controller_name}/${$code}/user/${$token}`
    this.form($url)
  }

  // 予約を確定する ボタン
  completed_button(e) {
    this.fadeIn()
    let $target = $(e.currentTarget)
    let $token = $target.data("token")
    let $code = $target.data("code")
    let _params = {
      url: `/${this.controller_name}/ajax_complete`,
      type: "PATCH",
      data: {"token": $token, "code" : $code},
      callback: (data) => {
        if (data.result) {
          let $url = `/${this.controller_name}/${data.code}/completed/${data.token}`
          this.form($url)
        }else{
          // ユーザ情報入力エラー
          if (data.error_type === "user") {
            let $url = `/${this.controller_name}/${data.code}/login/${$token}`
            this.form($url)

          // 予約重複エラー
          } else {
            $("#confirm-form-area").html(data.form)
            // スクロール
            this.scroll('.navbar')
          }
          this.fadeOut()
        }
      }
    }
    this.ajax(_params)

  }

  // submit ------------------------------------------------------------------------------------------------------------
  form(action){
    let $fm = $('<form />', {
      method: 'get',
      action: action,
    });
    $fm.appendTo(document.body)
    $fm.submit()
    $fm.remove()
  }

  // method ------------------------------------------------------------------------------------------------------------
  // ボタンアイコン切り替え
  active_reset(active, target){

    // 現在のactiveを削除
    active.removeClass('active')
    // アイコンを変更
    var active_icon = active.find('#icon-circle')
    active_icon.removeClass('fa-circle-dot')
    active_icon.addClass('fa-circle')

    // 新しくactiveを付与
    target.addClass('active')
    // アイコンを変更
    var icon = target.find('#icon-circle')
    icon.removeClass('fa-circle')
    icon.addClass('fa-circle-dot')

    return target

  }

  // 画面スクロール
  scroll(point){
    var offset = $(point).offset().top;
    $('html').animate({scrollTop: offset});
  }

  reset_timeline() {
    // hidden項目削除
    $('#reserve-date-hidden').val("")
    $('#start-time-hidden').val("")
    $('#end-time-hidden').val("")
    // お客様情報入力へボタン活性化
    $("#reserve-create-button").prop("disabled", true);
    // 予約内容確認へボタン活性化
    $("#reserve-create-confirm-button").prop("disabled", true);

  }

  set_timeline_hidden(data) {
    $('#date-first-hidden').val($('#hdn-date-first').val())
    $('#date-last-hidden').val($('#hdn-date-last').val())
    $('#prev-flg-hidden').val(data.form.attributes.prev_flg)
    $('#next-flg-hidden').val(data.form.attributes.next_flg)
  }

}

